<template>
  <v-row no-gutters style="padding: 0 15px">
    <v-col cols="12">
      <div
        style="
          font-size: 28px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          margin: 20px 0;
          color: #1b428b;
          font-weight: bold;
        "
      >
        Here is today's KPI report from VT Electron
      </div>
      <div style="margin: 0 16px 20px 16px">
        <div>
          <span style="font-size: 17px; color: #1b428b">Client: </span><span style="font-size: 16px">{{ tenant }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Report Date: </span
          ><span style="font-size: 16px">{{ report_date }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Report Time: </span
          ><span style="font-size: 16px">{{ report_time }}</span>
        </div>
        <div v-if="$route.name != 'report_kpi'">
          <span style="font-size: 17px; color: #0581c6">Recepients: </span
          ><span style="font-size: 16px">{{ final_recepient }}</span
          ><span v-if="recipients_number" style="font-size: 12px; color: #0581c6">
            ...+{{ recipients_number }} more</span
          >
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <div
        style="
          font-size: 24px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          color: #1b428b;
          font-weight: bold;
        "
      >
        KPI Report at a glance:
      </div>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" sm="12" class="d-flex">
              <v-card flat width="100%">
                <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
                  <RadialChartVT title="Static Split >= 5 Days" :chartData="chartData" print="true" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" class="kpi_stats_con">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff">
                  KPI Static Assets Stats
                </v-card-title>
                <v-card-text style="background: #ffffff">
                  <DataTableVT
                    v-if="updated_kpi_stats"
                    :headers="page_content.kpi_stats"
                    :items_list="updated_kpi_stats"
                    sort_by="PercDays"
                    :sort_asc="sort_asc"
                    no_sort="true"
                    item_key="Category"
                    no_pagination="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff">
                  Asset Status
                  <span class="chart-subtitle pl-2 text-subtitle-1 font-weight-medium primary--text"
                    >({{ kpi_data ? kpi_data.length : "-" }})</span
                  >
                </v-card-title>
                <v-card-text>
                  <DataTableVT
                    v-if="kpi_data"
                    :headers="page_content.kpi_table"
                    :items_list="kpi_data"
                    item_key="DeviceID"
                    no_pagination="true"
                    no_sort="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import RadialChartVT from "../components/RadialChartVT";
import DataTableVT from "../components/DataTableVT";
import { content } from "../../config/reports.json";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  name: "KPIReport",
  components: {
    RadialChartVT,
    DataTableVT,
  },
  props: {},
  watch: {},
  data: function () {
    return {
      tenant: "",
      recepient: "",
      report_date: "",
      report_time: "",
      snackbar: false,
      network_error: false,
      search_term: "",
      error_message: "",
      message: "",
      chartOptions: {
        slices: {
          0: { color: "#DB4366" },
          1: { color: "#3B918B" },
        },
        pieHole: 0.4,
      },
      kpi_data: null,
      kpi_stats: null,
      sort_asc: true,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    var d = new Date();
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0");
    var yyyy = d.getFullYear();
    var today = dd + "/" + mm + "/" + yyyy;
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.recepient = this.$auth.user.email;
    this.report_date = today;
    this.report_time = d.getHours() + ":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes() + ":" + d.getSeconds();
    this.get_kpi_data();
  },
  filters: {
    timeSince(date_string) {
      var date = new Date(date_string);
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + " years ago";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months ago";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days ago";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours ago";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes ago";
      }
      return Math.floor(seconds) + " seconds ago";
    },
  },
  methods: {
    async get_kpi_data() {
      //this.$store.commit("show_loader");
      this.network_error = false;
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let locations_req = axios.get(api_root + "/api/location/kpi_stats", header);
      let stats_req = axios.get(api_root + "/api/location/kpi_stats_summary", header);
      axios
        .all([locations_req, stats_req])
        .then(
          axios.spread((...responses) => {
            self.kpi_data = responses[0].data;
            self.kpi_stats = responses[1].data;
          })
        )
        .catch((e) => {
          self.network_error = true;
          console.log(e);
        });
    },
  },
  computed: {
    user_account: function () {
      return this.$auth.user;
    },
    final_recepient: function () {
      // if (this.$route.name == "report_fleet") {
      //   if (this.report_data && this.report_data[3]) {
      //     let recepients = "";
      //     let total = this.report_data[3].length;
      //     let limit = total > 7 ? 7 : total;
      //     for (var i = 0; i < limit; i++) {
      //       recepients = recepients
      //         ? recepients + "; " + this.report_data[3][i]["RecipientEmail"]
      //         : this.report_data[3][i]["RecipientEmail"];
      //     }
      //     return recepients;
      //   }
      //   return this.recepient;
      // }
      // return this.recepient;
      return this.recepient;
    },
    recipients_number: function () {
      return null;
    },
    updated_kpi_stats: function () {
      if (this.kpi_stats) {
        let temp_count = 0;
        let total = 0;
        this.kpi_stats.map((elem) => {
          total = total + elem.TotalDays;
        });
        let temp = this.kpi_stats.map((elem) => {
          if (elem.Category == "") {
            elem.Category = "No Category";
          }
          elem.PercDays = Math.round((elem.TotalDays / total) * 10000) / 100;
          temp_count = temp_count + elem.TotalTrolleys;
          return elem;
        });
        temp.push({
          Category: "Grand Total",
          TotalDays: total,
          PercDays: 100,
          TotalTrolleys: temp_count,
        });
        return temp;
      }
      return null;
    },
    chartData: function () {
      let temp = [
        [
          "Asset Location",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
      ];
      this.kpi_stats &&
        this.kpi_stats.map((elem) => {
          if (elem.TotalDays >= 5) {
            temp.push([
              elem.Category,
              elem.TotalDays,
              {
                msg: "Assets static days",
                title: elem.Category,
                footer: elem.TotalDays,
              },
            ]);
          }
        });
      return temp;
    },
  },
};
</script>
#test > tbody > tr:last-child { background:#ff0000; }
<style scoped lang="scss">
.kpi_stats_con {
  ::v-deep tbody > tr:last-child > td > div {
    font-weight: bold !important;
  }
}
</style>
